"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEnrichClient = void 0;
const react_1 = require("react");
const enrich_client_1 = require("@groupby/enrich-client");
const context_1 = require("../context");
const utils_1 = require("../utils");
/**
 * Creates a proxy wrapper around the HttpClient that handles async token fetching.
 * The wrapper intercepts method calls and ensures the token is fetched before each request.
 */
const createAsyncTokenClient = (host, getToken) => (new Proxy({}, {
    get(_target, namespace) {
        return new Proxy({}, {
            get(_nsTarget, method) {
                return (...args) => __awaiter(this, void 0, void 0, function* () {
                    const token = yield getToken();
                    const client = new enrich_client_1.HttpClient({ host, token });
                    return client[namespace][method](...args);
                });
            },
        });
    },
}));
const useEnrichClient = () => {
    const { getToken } = (0, react_1.useContext)(context_1.EnrichContext);
    const enrichHost = (0, utils_1.useGetEnrichAPIUrl)();
    return (0, react_1.useMemo)(() => createAsyncTokenClient(enrichHost, getToken), [enrichHost, getToken]);
};
exports.useEnrichClient = useEnrichClient;
exports.default = exports.useEnrichClient;
